import { CLIENT_LIFECYCLE_HEADERS, ClientProjectListResponseSchema, ClientProjectSchema, ClientStatementResponseSchema, ClientWipTotalResponseSchema, DeleteClientProjectResponseSchema, } from '@packages/types';
import { api, downloadFile } from '../client.js';
import { statementPeriodQuery } from '../statement-period-query.js';
export function listClientProjects(accountId, options) {
    const params = new URLSearchParams();
    if (options?.archivedOnly)
        params.set('archivedOnly', 'true');
    if (options?.includeArchived)
        params.set('includeArchived', 'true');
    if (options?.includeActivitySummary)
        params.set('includeActivitySummary', 'true');
    if (options?.includeExpenseSummary)
        params.set('includeExpenseSummary', 'true');
    if (options?.hasPendingActivities)
        params.set('hasPendingActivities', 'true');
    if (options?.cursor)
        params.set('cursor', options.cursor);
    if (options?.limit !== undefined)
        params.set('limit', String(options.limit));
    if (options?.clientId) {
        if (Array.isArray(options.clientId)) {
            for (const id of options.clientId)
                params.append('clientId', id);
        }
        else {
            params.set('clientId', options.clientId);
        }
    }
    if (options?.ids && options.ids.length > 0) {
        for (const id of options.ids)
            params.append('ids', id);
    }
    for (const name of options?.names ?? [])
        params.append('names', name);
    if (options?.search)
        params.set('search', options.search);
    if (options?.sortField)
        params.set('sortField', options.sortField);
    if (options?.sortDirection)
        params.set('sortDirection', options.sortDirection);
    if (options?.status)
        params.set('status', options.status);
    const qs = params.toString();
    return api(`/accounts/${accountId}/client-projects${qs ? `?${qs}` : ''}`, ClientProjectListResponseSchema, {
        headers: CLIENT_LIFECYCLE_HEADERS,
    });
}
export function getClientProject(accountId, clientProjectId) {
    return api(`/accounts/${accountId}/client-projects/${clientProjectId}`, ClientProjectSchema, {
        headers: CLIENT_LIFECYCLE_HEADERS,
    });
}
export function getClientProjectWipTotal(accountId, clientProjectId) {
    return api(`/accounts/${accountId}/client-projects/${clientProjectId}/wip-total`, ClientWipTotalResponseSchema);
}
/** A matter's accounts-receivable statement: the business entries tagged with this matter, with its own opening balance. */
export function getClientProjectStatement(accountId, clientProjectId, options) {
    return api(`/accounts/${accountId}/client-projects/${clientProjectId}/statement${statementPeriodQuery(options)}`, ClientStatementResponseSchema);
}
/** Download a matter's business statement as a PDF for the period (nothing is stored). */
export function exportClientProjectStatementPdf(accountId, clientProjectId, options) {
    return downloadFile(`/accounts/${accountId}/client-projects/${clientProjectId}/statement.pdf${statementPeriodQuery(options)}`, 'matter-statement.pdf');
}
export function exportClientProjectStatementXlsx(accountId, clientProjectId, options) {
    return downloadFile(`/accounts/${accountId}/client-projects/${clientProjectId}/statement.xlsx${statementPeriodQuery(options)}`, 'matter-statement.xlsx');
}
export function createClientProject(accountId, input) {
    return api(`/accounts/${accountId}/client-projects`, ClientProjectSchema, {
        method: 'POST',
        headers: CLIENT_LIFECYCLE_HEADERS,
        body: input,
    });
}
export function updateClientProject(accountId, clientProjectId, input) {
    return api(`/accounts/${accountId}/client-projects/${clientProjectId}`, ClientProjectSchema, {
        method: 'PATCH',
        headers: CLIENT_LIFECYCLE_HEADERS,
        body: input,
    });
}
export function archiveClientProject(accountId, clientProjectId) {
    return api(`/accounts/${accountId}/client-projects/${clientProjectId}`, DeleteClientProjectResponseSchema, {
        method: 'DELETE',
    });
}
